import React, { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Board from './Board';
import { Box, useTheme } from '@mui/material';
import { setWhiteBoardDimentions } from '../../../features/screenSharing/screenSharingSlice';


const Boards = () => {
    const theme = useTheme();
    const { panels } = useSelector((store) => store.tabs)
    const containerRef = useRef()
    const dispatch = useDispatch();
    
    useEffect(() => {
        const timer = setTimeout(() => {
            if (!containerRef.current) {
                console.error('[Boards] containerRef.current is null');
                return;
            }
            const rect = containerRef.current.getBoundingClientRect();
            dispatch(setWhiteBoardDimentions({ 
                dimensions: { 
                    x: rect.x, 
                    y: rect.y + 36, 
                    width: rect.width, 
                    height: rect.height, 
                    fullWidth: window.innerWidth, 
                    fullHeight: window.innerHeight, 
                    PR: window.devicePixelRatio, 
                    dir: theme.direction, 
                    screenSharing: false 
                } 
            }));
        }, 200);
        
        return () => clearTimeout(timer);
    }, [dispatch, theme.direction])

    return (
        <Box>
            <Box ref={containerRef} sx={{ height: 'calc(100vh - 200px)' }}>
                {panels.map(panel => <Board key={panel.id} panel={panel} />)}
            </Box>
        </Box>

    )
}

export default Boards